import styled from 'styled-components';

export const SectionContainer = styled.div`
  padding: 24px 0;

  @media (max-width: 768px) {
    padding: 16px 0;
  }
`;

export const SectionHeader = styled.div`
  margin-bottom: 24px;

  @media (max-width: 768px) {
    margin-bottom: 16px;
  }
`;

export const SectionTitle = styled.h2`
  font-family: Roboto;
  font-weight: 600;
  font-size: 24px;
  color: #353839;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    font-size: 20px;
    gap: 8px;
  }
`;

export const TitleIcon = styled.span`
  font-size: 28px;
  line-height: 1;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 3px;
  background: linear-gradient(
    90deg,
    #f78e1e 0%,
    #ff9500 50%,
    rgba(247, 142, 30, 0) 100%
  );
  border-radius: 2px;
  box-shadow: 0 2px 4px rgba(247, 142, 30, 0.2);
`;

export const ScrollContainer = styled.div<{ $autoScroll?: boolean }>`
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: #f78e1e #f5f5f5;

  ${(props) =>
    props.$autoScroll &&
    `
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  `}

  ${(props) =>
    !props.$autoScroll &&
    `
    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f5f5f5;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #f78e1e;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #ff9500;
    }
  `}
`;

export const ProductGrid = styled.div<{ $autoScroll?: boolean }>`
  display: flex;
  gap: 16px;
  padding-bottom: ${(props) => (props.$autoScroll ? '0' : '8px')};

  flex-wrap: nowrap;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const ProductCard = styled.div<{ $isClickable?: boolean }>`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: ${(props) => (props.$isClickable ? 'pointer' : 'default')};
  display: flex;
  flex-direction: column;
  position: relative;

  min-width: 200px;
  max-width: 200px;
  flex-shrink: 0;

  ${(props) =>
    props.$isClickable &&
    `
    &:hover {
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }
  `}

  @media (max-width: 768px) {
    min-width: 160px;
    max-width: 160px;

    &:hover {
      transform: none;
    }
  }
`;

export const ProductImageContainer = styled.div`
  width: 100%;
  padding-top: 100%;
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
`;

export const ProductImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ImagePlaceholder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  color: #8c8c8c;
  font-size: 48px;
`;

export const PlaceholderIcon = styled.div`
  font-size: 48px;
  opacity: 0.3;
`;

export const ExclusiveBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: linear-gradient(135deg, #f78e1e 0%, #ff9500 100%);
  color: #fff;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 1;
`;

export const ProductInfo = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const ProductName = styled.h3`
  font-family: Roboto;
  font-weight: 500;
  font-size: 14px;
  color: #353839;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.4;
  min-height: 2.8em;
`;

export const ConceptName = styled.p`
  font-family: Roboto;
  font-weight: 700;
  font-size: 13px;
  text-transform: uppercase;
  color: #353839;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 1.4;
  min-height: 1.4em;
`;

export const ProducerName = styled.div`
  font-family: Roboto;
  font-size: 12px;
  color: #8c8c8c;
`;

export const ProducerLabel = styled.span`
  font-weight: 400;
`;

export const ProducerValue = styled.span`
  font-weight: 500;
  color: #353839;
  margin-left: 4px;
`;

export const PriceContainer = styled.div`
  font-family: Roboto;
  font-size: 12px;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
`;

export const PriceLabel = styled.span`
  font-weight: 400;
  color: #8c8c8c;
`;

export const PriceValue = styled.span`
  font-weight: 700;
  color: #f78e1e;
  margin-left: 4px;
  font-size: 14px;
`;

export const EmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  width: 100%;
  grid-column: 1 / -1;
`;

export const LoadingContainer = styled.div`
  display: flex;
  gap: 16px;
  overflow-x: auto;
  width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #f78e1e #f5f5f5;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #f78e1e;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #ff9500;
  }

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const SkeletonCard = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  min-width: 200px;
  max-width: 200px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    min-width: 160px;
    max-width: 160px;
  }
`;

export const SkeletonImage = styled.div`
  width: 100%;
  padding-top: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const SkeletonContent = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkeletonLine = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '16px'};
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;
